<template>
  <div class="appResponsiveHeight">
    <v-app id="inspire" :class="hideContainer ? 'register-container' : 'wrapper'">
      <v-app-bar app elevate-on-scroll elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
        class="custom-navbar" v-if="!$route.meta.noSidebar">
        <v-container class="fill-height app-bar-container">
          <v-app-bar-nav-icon class="d-md-none d-sm-flex d-xl-none d-lg-none"
            @click="drawer = !drawer"></v-app-bar-nav-icon>
          <DashboardView></DashboardView>
          <audio id="notification-bell" src="sounds/notification-bell.wav" preload="auto"></audio>
          <v-spacer></v-spacer>
          <ul class="top-links-list">
            <li>
              <v-tooltip bottom content-class="tooltip-dark">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab link small to="/internal-transfer" :ripple="false" elevation="0" v-bind="attrs" v-on="on"
                    :color="$vuetify.theme.dark ? '#1A2A3E' : '#F8F6FC'">
                    <v-icon color="#039de9">mdi-swap-horizontal</v-icon>
                  </v-btn>
                </template>
                <span class="tooltip-text">Internal Transfer</span>
              </v-tooltip>
            </li>
            <li>
              <v-tooltip bottom content-class="tooltip-dark">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab link small to="/withdraw" :ripple="false" elevation="0" v-bind="attrs" v-on="on"
                    :color="$vuetify.theme.dark ? '#1A2A3E' : '#F8F6FC'">
                    <v-icon color="#039de9">mdi-tray-arrow-up</v-icon>
                  </v-btn>
                </template>
                <span class="tooltip-text">Withdraw</span>
              </v-tooltip>
            </li>
            <li>
              <v-tooltip bottom content-class="tooltip-dark">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab link small to="/deposit" :ripple="false" elevation="0" v-bind="attrs" v-on="on"
                    :color="$vuetify.theme.dark ? '#1A2A3E' : '#F8F6FC'">
                    <v-icon color="#039de9">mdi-tray-arrow-down</v-icon>
                  </v-btn>
                </template>
                <span class="tooltip-text">Deposit</span>
              </v-tooltip>
            </li>
          </ul>
          <PanelSwitcherView v-if="hasIbStatus"></PanelSwitcherView>
          <!-- <SignalsView></SignalsView>
          <LanguageMenu></LanguageMenu> -->
          <SwitcherView></SwitcherView>
          <NotificationView></NotificationView>
          <LogoutView></LogoutView>
        </v-container>
      </v-app-bar>
      <div :class="hideContainer ? 'container-fluid' : 'custom-container'">
        <v-row no-gutters>
          <v-col xl="2" class="custom-width-navigation-drawer" v-if="!$route.meta.noSidebar">
            <div class="navigation-drawer-container">
              <v-navigation-drawer v-model="drawer" :permanent="$vuetify.breakpoint.mdAndUp" width="240"
                class="navigation-drawer sidebar-navigation-drawer"
                :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                <AdminLogo></AdminLogo>
                <AllMenu></AllMenu>
              </v-navigation-drawer>
              <HelpAssistantWidget v-if="!$route.meta.noSidebar" />
            </div>
          </v-col>
          <v-col class="custom-width-main registration-page">
            <v-main>
              <router-view></router-view>
            </v-main>
          </v-col>
        </v-row>
      </div>
    </v-app>
  </div>
</template>

<script>
import AdminLogo from "./components/SideBar/AdminLogo.vue";
import AllMenu from "./components/SideBar/AllMenu.vue";
import DashboardView from "./components/TopBar/DashboardView.vue";
import LanguageMenu from "./components/TopBar/LanguageMenu.vue";
import LogoutView from "./components/TopBar/LogoutView.vue";
import NotificationView from "./components/TopBar/NotificationView.vue";
import PanelSwitcherView from "./components/TopBar/PanelSwitcherView.vue";
import SignalsView from "./components/TopBar/SignalsView.vue";
import SwitcherView from "./components/TopBar/SwitcherView.vue";
import { mapActions, mapState } from "vuex";
import { PROFILE__ACTIONS } from "@/store/action-types";
import HelpAssistantWidget from "./components/assistant/HelpAssistantWidget.vue";

export default {
  data() {
    return {
      drawer: null,
    };
  },

  components: {
    LanguageMenu,
    NotificationView,
    SignalsView,
    SwitcherView,
    DashboardView,
    LogoutView,
    AdminLogo,
    AllMenu,
    PanelSwitcherView,
    HelpAssistantWidget,
  },

  watch: {
    client: {
      handler(val) {
        if (val && val.theme_preference !== undefined) {
          this.$vuetify.theme.dark = val.theme_preference === 1;
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapState("profile", ["client"]),

    hideContainer() {
      return (
        this.$route.name === "/" ||
        this.$route.name === "Login" ||
        this.$route.name === "CreateAccount" ||
        this.$route.name === "Registration" ||
        this.$route.name === "SendOtp" ||
        this.$route.name === "ForgotPassword"
      );
    },

    hasIbStatus() {
      return this.$store.state.authentication.ib_status === 1;
    }
  },

  methods: {
    ...mapActions("profile", ["GETPROFILE"]),
  },

  async created() {
    await this[PROFILE__ACTIONS.GETPROFILE]();
  },
};
</script>

<style scoped>
.appResponsiveHeight {
  height: 100vh;
  overflow-y: hidden;
  overflow-x: hidden;
}
</style>